import axios from "axios";
import { API } from "../../../api/api";

export const getPortfolio = async () => await axios.get(API.url + "/projects?populate=*").then((res) => res.data.data);

export const getPortfolioPage = () =>
  axios.get(API.url + "/portfolio?populate[hero][populate]=*&populate[customers][populate]=*").then((res) => res.data.data.attributes);
